import { Paper, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, TablePagination, Button } from '@mui/material';
import { useState } from 'react';
import UpdateNotification from './UpdateNotification';
import DeleteNotification from './DeleteNotification';

const columns = [
    { id: 'id', label: 'ID', minWidth: 120 },
    { id: 'title', label: 'Title', minWidth: 170 },
    { id: 'content', label: 'Content', minWidth: 170 },
    { id: 'notificationTypeName', label: 'Notification Type', minWidth: 170 },
    { id: 'createdBy', label: 'Created By', minWidth: 170 },
    { id: 'createdDate', label: 'Created Date', minWidth: 170, type: 'date' },
    { id: 'csUserName', label: 'CS User Name', minWidth: 170 },
    { id: 'customerLoginUserName', label: 'Customer Login Username', minWidth: 170 },
    { id: 'notificationRedirectTypeName', label: 'Redirect Type', minWidth: 170 },
    { id: 'externalUrl', label: 'External Url', minWidth: 170 },
];

function StickyHeadTable({ notifications, notificationTypes, customerLoginUserNameOptions, fetchNotifications, userNameOptions, redirectTypes }) {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden', marginTop: '50px' }}>
            <TableContainer sx={{ maxHeight: 440 }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            {columns.map((column) => (
                                <TableCell key={column.id} align={column.align} style={{ minWidth: column.minWidth }}>
                                    {column.label}
                                </TableCell>
                            ))}
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {notifications.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                            return (
                                <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                                    {columns.map((column) => {
                                        let value = row[column.id];
                                        if (column.type && column.type === 'date') {
                                            if (value) {
                                                const timeString12hr = new Date(
                                                    '1970-01-01T' + value.split('T')[1] + 'Z'
                                                ).toLocaleTimeString('en-US', {
                                                    timeZone: 'UTC',
                                                    hour12: true,
                                                    hour: 'numeric',
                                                    minute: 'numeric',
                                                    second: 'numeric'
                                                });
                                                value = `${value.split('T')[0]} ${timeString12hr}`;
                                            }
                                        }
                                        return (
                                            <TableCell key={column.id} align={column.align}>
                                                {typeof value === 'boolean'
                                                    ? value.toString()
                                                    : column.format && typeof value === 'number'
                                                    ? column.format(value)
                                                    : value}
                                                {/* {column.format && typeof value === 'number' ? column.format(value) : value} */}
                                            </TableCell>
                                        );
                                    })}
                                    <TableCell>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '10px'
                                            }}
                                        >
                                            <UpdateNotification
                                                notification={row}
                                                notificationTypes={notificationTypes}
                                                customerLoginUserNameOptions={customerLoginUserNameOptions}
                                                onUpdate={fetchNotifications}
                                                userNameOptions={userNameOptions}
                                                redirectTypes={redirectTypes}
                                            />
                                            <DeleteNotification notification={row} onDelete={fetchNotifications} />
                                        </Box>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component="div"
                count={notifications.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
}

export default StickyHeadTable;
